import { render, staticRenderFns } from "./PeaceTower.vue?vue&type=template&id=9c3209fa&"
import script from "./PeaceTower.vue?vue&type=script&lang=js&"
export * from "./PeaceTower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports